export enum LoanTypeEnum {
  SENIOR_LOAN = 'SeniorLoan',
  BRIDGE_LOAN = 'BridgeLoan',
  MEZZANINE = 'Mezzanine',
  WHOLE_LOAN = 'WholeLoan',
  PREFERRED_EQUITY = 'PreferredEquity',
  SENIOR_PLUS_MEZZANINE = 'SeniorPlusMezzanine',
}
